import {Icon} from '@benchling/nucleus-ui';
import {Alert} from '@mantine/core';
import React from 'react';

import {MismatchStatus} from './useSchemaMismatchDetection';
import type {SchemaMismatchResult} from './useSchemaMismatchDetection';

interface SchemaMismatchAlertProps {
  mismatchResult: SchemaMismatchResult;
}

export default function SchemaMismatchAlert({mismatchResult}: SchemaMismatchAlertProps): JSX.Element | null {
  if (mismatchResult.status !== MismatchStatus.BLOCKED) {
    return null;
  }

  return (
    <Alert
      variant="error"
      mb="sm"
      icon={<Icon icon="exclamation-circle" />}
      styles={{root: {flexShrink: 0}}}
      title="The schema you selected does not support the creation of salt or solvent molecules."
    >
      {mismatchResult.message}
    </Alert>
  );
}
